import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Text } from 'components/common/Elements/Elements';
import TrueFalse from './TrueFalse/TrueFalse';
import DropList from './DropList/DropList';
import { Link } from '@p81-common/ui';

import { textToDate } from 'utils/common';

import classes from './FeatureItem.module.scss';

const FeatureItem = ({ data }) => {
  const { t } = useTranslation(['activity']);
  if (!data.subtable) {
    return (
      <li className={cn(classes.item, classes.item_noSubTable)}>
        {data.title === t('activity:customers.MONITORING_DASHBOARD') &&
        data.value ? (
          <span>
            <Text size={4}>{data.title}</Text>
            <div className={classes.featureUsageGreenDot} />
            <Text className={classes.monitoringDashboardUsageDate} size={4}>
              {textToDate(data.date)}
            </Text>
          </span>
        ) : data.value && data.link ? (
          <Link to={data.link}>
            <Text size={4}>{data.title}</Text>
          </Link>
        ) : (
          <Text size={4}>{data.title}</Text>
        )}
        {data.isActButtonVisible && (
          <Text size={4} className={classes.featureSwitch}>
            <Link table href="#" onClick={data.onChange}>
              {data.value ? 'Turn Off' : 'Turn On'}
            </Link>
          </Text>
        )}
        <TrueFalse value={data.value} />
      </li>
    );
  }
  return (
    <li className={cn(classes.item)}>
      <DropList {...data} />
    </li>
  );
};

FeatureItem.propTypes = {
  data: PropTypes.object
};

export default FeatureItem;
